import { cn } from "@/lib/cn";
import type { Trait } from "@/pfp/generator";

export function TraitCard({
  trait,
  totalWeight,
  onChange,
  onRemove,
}: {
  trait: Trait;
  totalWeight: number;
  onChange: (patch: Partial<Trait>) => void;
  onRemove: () => void;
}) {
  const pct = totalWeight > 0 ? (Math.max(0, trait.weight) / totalWeight) * 100 : 0;
  return (
    <div className="group relative flex flex-col overflow-hidden rounded-lg border border-border bg-card transition hover:border-foreground/40">
      <div className="aspect-square w-full overflow-hidden bg-muted">
        <img
          src={trait.imageUrl}
          alt={trait.name}
          loading="lazy"
          decoding="async"
          className="h-full w-full object-cover"
        />
      </div>
      <div className="p-2">
        <input
          className="input h-7 w-full text-xs"
          value={trait.name}
          onChange={(e) => onChange({ name: e.target.value })}
          aria-label="Trait name"
        />
        <div className="mt-1.5 flex items-center gap-2">
          <input
            type="range"
            min={0}
            max={10}
            step={1}
            value={Math.min(10, Math.max(0, trait.weight))}
            onChange={(e) => onChange({ weight: Number(e.target.value) })}
            className="h-1 flex-1 cursor-pointer appearance-none rounded-full bg-muted accent-foreground"
            aria-label={`Rarity weight for ${trait.name}`}
          />
          <span className="w-10 shrink-0 text-right text-[11px] tabular-nums text-muted-foreground">
            {pct.toFixed(0)}%
          </span>
        </div>
      </div>
      <button
        type="button"
        onClick={onRemove}
        title="Remove trait"
        className={cn(
          "absolute right-1 top-1 inline-flex h-5 w-5 items-center justify-center rounded-md",
          "bg-background/80 text-muted-foreground opacity-0 transition hover:text-foreground",
          "group-hover:opacity-100",
        )}
      >
        ×
      </button>
    </div>
  );
}
